// extracted by mini-css-extract-plugin
module.exports = {"root":"ImagePreviewModal_root__1tiYG","image":"ImagePreviewModal_image__RVBvS"};